// extracted by mini-css-extract-plugin
module.exports = {"playbackrate_select":"W_bAH","player-speed-wrapper":"_2B2qq","player-speed-controls":"ffxnd"};